/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import updateSettings from './handlers/settings/updateSettings';
import { EventHubPayload, SETTINGS_UPDATE_PROJECT_DETAILS } from './types';

const handlers: { [key: string]: (data: any, dependencies: any) => void } = {
  [SETTINGS_UPDATE_PROJECT_DETAILS]: updateSettings,
};

const handleEvents = (payload: EventHubPayload, dependencies: any) => {
  const { data, key } = payload.data;
  const handler = handlers[key];
  if (handler) {
    handler(data, dependencies);
  }
};

export default handleEvents;
